import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../components/ui/button";
import { useEffect, useState } from "react";
import { useI18n } from "../config/i18n";
import { Calendar, MapPin } from "lucide-react";
let lang = undefined;
const EventCard = ({ event, t, isPast }) => (_jsxs("div", { className: `p-6 rounded-lg border ${isPast ? "opacity-75" : ""}`, style: {
        background: `linear-gradient(270deg, ${t.colors.secondary}${isPast ? "10" : "20"}, ${t.colors.dark})`,
        borderColor: isPast ? t.colors.secondary : t.colors.primary,
    }, children: [_jsx("p", { style: { color: isPast ? t.colors.light : t.colors.accent }, className: "font-bold text-xl", children: event.title }), _jsxs("div", { className: "flex flex-row items-center gap-1 mt-2", style: { color: t.colors.light }, children: [_jsx(Calendar, { className: "mr-2 h-4 w-4" }), _jsx("p", { className: "text-sm md:text-lg", children: new Date(event.date).toLocaleDateString(!lang || lang === "it" ? "it-IT" : "en-EN", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    }) })] }), event.location && (_jsxs("div", { className: "flex flex-row items-center gap-1 mt-2", style: { color: t.colors.light }, children: [_jsx(MapPin, { className: "mr-2 h-4 w-4" }), " ", _jsx("a", { href: event.location.link, target: "_blank", rel: "noopener noreferrer", style: { color: t.colors.secondaryLight }, className: "text-sm md:text-lg underline hover:opacity-80 inline-block", children: event.location.label })] })), _jsx("p", { children: event.link && (_jsx(Button, { onClick: () => { var _a; return window.open((_a = event.link) === null || _a === void 0 ? void 0 : _a.url, "_blank"); }, className: "mt-2", style: {
                    padding: "10px 15px",
                    borderRadius: 5,
                    color: t.colors.dark,
                    background: t.colors.primary,
                }, children: event.link.label })) })] }));
const EventSection = ({ title, events, t, past }) => {
    if (events.length === 0)
        return null;
    return (_jsxs("div", { className: "w-full max-w-4xl mb-16", children: [_jsx("h3", { className: "text-2xl md:text-3xl font-medium uppercase tracking-[0.15em] mb-3", style: { color: t.colors.primaryLight }, children: title }), _jsx("div", { className: "space-y-4", children: events.map((event, idx) => (_jsx(EventCard, { event: event, t: t, isPast: past }, idx))) })] }));
};
export function EventsSection({ t }) {
    lang = useI18n().lang;
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);
    useEffect(() => {
        if (!t.events || t.events.length === 0) {
            setUpcomingEvents([]);
            setPastEvents([]);
            return;
        }
        const now = new Date().getTime();
        const upcoming = t.events
            .filter(event => new Date(event.date).getTime() >= now)
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
        const past = t.events
            .filter(event => new Date(event.date).getTime() < now)
            .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        setUpcomingEvents(upcoming);
        setPastEvents(past);
    }, [t.events]);
    if (!t.events || t.events.length === 0) {
        return null;
    }
    const upcomingTitle = lang === "it" ? "Prossimi Eventi" : "Upcoming Events";
    const pastTitle = lang === "it" ? "Eventi Passati" : "Past Events";
    // Non renderizzare la sezione se entrambi gli array sono vuoti
    if (upcomingEvents.length === 0 && pastEvents.length === 0) {
        return null;
    }
    return (_jsxs("section", { id: "events", className: "relative min-h-screen flex flex-col items-center justify-center py-20 px-4 overflow-hidden", children: [_jsx(EventSection, { title: upcomingTitle, events: upcomingEvents, t: t, past: false }), _jsx(EventSection, { title: pastTitle, events: pastEvents, t: t, past: true })] }));
}
